/** @format */

export const CHATS_PAGE_SIZE = 20;

/** Parse GET /v1/chats/ page — prefers has_more from API, falls back to page length. */
export function parseChatsPageResponse(res) {
  const payload = res?.data ?? res ?? {};
  const chats = payload.chats ?? [];
  const hasMore = payload.has_more ?? chats.length === CHATS_PAGE_SIZE;
  const total = payload.total;
  return { chats, hasMore, total };
}
